<script lang="ts">
    import {Component, Prop, toNative, Vue} from 'vue-facing-decorator'
    import Breadcrumbs from '~src/components/Breadcrumbs.vue'

    @Component({mixins: [Breadcrumbs]})
    export class ExtraServiceBreadcrumbs extends Vue {
        @Prop({required: true}) searchRequest
        @Prop({default: () => {}}) product

        get items() {
            const getSearchPageLabel = () =>
                extraServicesRuntimeStore.city.name
                    ? `${extraServicesRuntimeStore.city.name}, ${extraServicesRuntimeStore.city.countryName}`
                    : null
            const addSearchPageLink = items => {
                items.push({
                    title: getSearchPageLabel(),
                    to: extraServicesRuntimeStore.searchPageLink(this.searchRequest),
                    exact: true,
                })
            }
            const addInfoPageLink = items => {
                items.push({
                    title: this.product.info.name,
                    to: {name: 'extraService', query: {name: this.product.info.name}},
                    exact: true,
                })
            }
            const route = useRoute()
            const name = route.name
            const items = [this.homeItem]
            //TODO Add all routes
            switch (name) {
                case 'extraServices':
                    items.push({
                        title: getSearchPageLabel(),
                        disabled: true,
                    })
                    break
                case 'extraService':
                    addSearchPageLink(items)
                    items.push({
                        title: decodeURIComponent(route.query.name),
                        disabled: true,
                    })
                    break
                case 'extraServiceBooking':
                    addSearchPageLink(items)
                    addInfoPageLink(items)
                    items.push({
                        title: this.$t('reservation'),
                        disabled: true,
                    })
                    break
                case 'extraServiceConfirmation':
                    addSearchPageLink(items)
                    addInfoPageLink(items)
                    items.push({
                        title: this.$t('confirmation'),
                        disabled: true,
                    })
                    break
            }
            return items
        }
    }

    export default {...toNative(ExtraServiceBreadcrumbs), ssrRender: Breadcrumbs.ssrRender}
</script>
